import React from "react";

const FileUpload = ({ label, name, value, onChange }) => {
  let fileName = "No file chosen";

  if (value) {
    if (typeof value === "string") {
      const cleanUrl = value.split("?")[0];
      const parts = cleanUrl.split("/");
      fileName = parts[parts.length - 1];
    } else if (value.name) {
      fileName = value.name;
    }
  }

  return (
    <div>
      <label className="block mb-1 font-medium text-gray-700">{label}</label>
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-700 truncate">{fileName}</span>
      </div>
      <input
        type="file"
        name={name}
        onChange={onChange}
        className="hidden"
        id={`upload-${label}`}
      />
      <label
        htmlFor={`upload-${label}`}
        className="cursor-pointer text-blue-500 underline"
      >
        Choose file
      </label>
    </div>
  );
};

export default FileUpload;

